/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// ----------------------------------------------------- //
// Owl Carousel
// ----------------------------------------------------- //
$(function () {
	var galleryClass = ".slider-gallery-section.descriptive-gallery .gallery-wrapper",
			galleryClass2 = ".slider-gallery-section.plain-gallery .gallery-wrapper",
      logoClass = ".index-logo-wrapper",
      ctaClass = ".index-cta-wrapper",
      productsClass = ".product-slider-wrapper",
      productsRClass = ".product-recommendation-outer .index-products-wrapper",
      productstimerClass = ".timer-product-wrapper",
      relatedBlogClass = ".related-blog-slider",
      //brandClass = '.brands-carousel',
      profileTeamClass = ".team-slider-wrapper";

	sliderGallery(galleryClass);
	plainGallery(galleryClass2);
	logoCarousel(logoClass);
	ctaCarousel(ctaClass);

	producttimerCarousel(productstimerClass);
	relatedBlogCarousel(relatedBlogClass);
	profileTeamCarousel(profileTeamClass);

	setTimeout(function () {
		//brandCarousel(brandClass);
		productCarousel(productsClass);
	}, 1200);
	setTimeout(function () {
		productRCarousel(productsRClass);
	}, 2000);

	function sliderGallery(x) {
		$(x).addClass("owl-carousel").addClass("owl-theme");
		$(x).owlCarousel({
			loop: true,
			nav: true,
			dots: false,
			items: 2,
      autoHeight: true,
			responsive: {
				0: {
					items: 2,
          margin: 10
				},
				950: {
					items: 3,
					margin: 20
				},
				1300: {
					items: 4,
					margin: 20
				},
			},
		});
	}

	function plainGallery(x) {
		$(x).addClass("owl-carousel").addClass("owl-theme");
		$(x).owlCarousel({
			loop: true,
			nav: true,
			dots: false,
			margin: 5,
			responsive: {
				0: {
					items: 2
				},
				950: {
					items: 3
				},
				1300: {
					items: 5
				}
			}
		});
	}

	function logoCarousel(x = ".index-logo-wrapper") {
		$(x).addClass("owl-carousel").addClass("owl-theme");
		$(x).owlCarousel({
			loop: true,
			dots: false,
			autoWidth: true,
			navText: [
				'<svg viewBox="0 0 18 32" class="prev"><path d="M15.791 30.7773L17.1582 29.4785C17.4316 29.1367 17.4316 28.5898 17.1582 28.3164L4.78516 15.875L17.1582 3.50195C17.4316 3.22852 17.4316 2.68164 17.1582 2.33984L15.791 1.04102C15.4492 0.699219 14.9707 0.699219 14.6289 1.04102L0.273438 15.3281C0 15.6699 0 16.1484 0.273438 16.4902L14.6289 30.7773C14.9707 31.1191 15.4492 31.1191 15.791 30.7773Z" fill="#2A2A2A"/></svg>',
				'<svg viewBox="0 0 18 32" class="next"><path d="M1.64062 1.04102L0.273438 2.33984C0 2.68164 0 3.22852 0.273438 3.50195L12.6465 15.875L0.273438 28.3164C0 28.5898 0 29.1367 0.273438 29.4785L1.64062 30.7773C1.98242 31.1191 2.46094 31.1191 2.80273 30.7773L17.1582 16.4902C17.4316 16.1484 17.4316 15.6699 17.1582 15.3281L2.80273 1.04102C2.46094 0.699219 1.98242 0.699219 1.64062 1.04102Z" fill="#2A2A2A"/></svg>',
			],
			responsive: {
				0: {
					items: 3,
					margin: 35,
					nav: false,
				},
				641: {
					items: 2,
					margin: 35,
					nav: true,
				},
				1000: {
					items: 3,
					margin: 55,
					nav: true,
				},
			},
		});
	}

	function ctaCarousel(x = ".index-cta-wrapper") {
		$(x).addClass("owl-carousel").addClass("owl-theme");
		$(x).owlCarousel({
			loop: false,
			dots: false,
			autoWidth: true,
			onInitialized: function(){ stage = jQuery('.owl-stage'); stage.width(stage.width() * 2); },
			onRefreshed: function(){ stage = jQuery('.owl-stage'); stage.width(stage.width() * 2); },
			navText: [
				'<svg viewBox="0 0 18 32" class="prev"><path d="M15.791 30.7773L17.1582 29.4785C17.4316 29.1367 17.4316 28.5898 17.1582 28.3164L4.78516 15.875L17.1582 3.50195C17.4316 3.22852 17.4316 2.68164 17.1582 2.33984L15.791 1.04102C15.4492 0.699219 14.9707 0.699219 14.6289 1.04102L0.273438 15.3281C0 15.6699 0 16.1484 0.273438 16.4902L14.6289 30.7773C14.9707 31.1191 15.4492 31.1191 15.791 30.7773Z" fill="#2A2A2A"/></svg>',
				'<svg viewBox="0 0 18 32" class="next"><path d="M1.64062 1.04102L0.273438 2.33984C0 2.68164 0 3.22852 0.273438 3.50195L12.6465 15.875L0.273438 28.3164C0 28.5898 0 29.1367 0.273438 29.4785L1.64062 30.7773C1.98242 31.1191 2.46094 31.1191 2.80273 30.7773L17.1582 16.4902C17.4316 16.1484 17.4316 15.6699 17.1582 15.3281L2.80273 1.04102C2.46094 0.699219 1.98242 0.699219 1.64062 1.04102Z" fill="#2A2A2A"/></svg>',
			],
			nav: true,
			responsive: {
				0: {
					items: 1,
					margin: 10,
				},
				641: {
					items: 2,
					margin: 20,
				},
			},
		});
	}

	function productCarousel(x = ".product-slider-wrapper") {
		$(x).addClass("owl-carousel").addClass("owl-theme");
		$(x).owlCarousel({
			loop: false,
			dots: false,
			items: 5,
			navText: [
				'<svg viewBox="0 0 18 32" class="prev"><path d="M15.791 30.7773L17.1582 29.4785C17.4316 29.1367 17.4316 28.5898 17.1582 28.3164L4.78516 15.875L17.1582 3.50195C17.4316 3.22852 17.4316 2.68164 17.1582 2.33984L15.791 1.04102C15.4492 0.699219 14.9707 0.699219 14.6289 1.04102L0.273438 15.3281C0 15.6699 0 16.1484 0.273438 16.4902L14.6289 30.7773C14.9707 31.1191 15.4492 31.1191 15.791 30.7773Z" fill="#2A2A2A"/></svg>',
				'<svg viewBox="0 0 18 32" class="next"><path d="M1.64062 1.04102L0.273438 2.33984C0 2.68164 0 3.22852 0.273438 3.50195L12.6465 15.875L0.273438 28.3164C0 28.5898 0 29.1367 0.273438 29.4785L1.64062 30.7773C1.98242 31.1191 2.46094 31.1191 2.80273 30.7773L17.1582 16.4902C17.4316 16.1484 17.4316 15.6699 17.1582 15.3281L2.80273 1.04102C2.46094 0.699219 1.98242 0.699219 1.64062 1.04102Z" fill="#2A2A2A"/></svg>',
			],
			nav: true,

			responsive: {
				0: {
					items: 1,
					margin: 10,
					nav: false,
				},
				575: {
					items: 3,
					margin: 15,
					nav: false,
				},
				992: {
					items: 4,
					margin: 26,
					nav: true,
				},
				1400: {
					items: 5,
					margin: 26,
					nav: true,
				},
				1700: {
					items: 5,
					margin: 26,
					nav: true,
				},
			},
		});
	}
	function productRCarousel(
		x = ".product-recommendation-outer .index-products-wrapper"
	) {
		$(x).addClass("owl-carousel").addClass("owl-theme");
		$(x).owlCarousel({
			loop: false,
			dots: false,
			autoWidth: false,
			items: 5,
			navText: [
				'<svg viewBox="0 0 18 32" class="prev"><path d="M15.791 30.7773L17.1582 29.4785C17.4316 29.1367 17.4316 28.5898 17.1582 28.3164L4.78516 15.875L17.1582 3.50195C17.4316 3.22852 17.4316 2.68164 17.1582 2.33984L15.791 1.04102C15.4492 0.699219 14.9707 0.699219 14.6289 1.04102L0.273438 15.3281C0 15.6699 0 16.1484 0.273438 16.4902L14.6289 30.7773C14.9707 31.1191 15.4492 31.1191 15.791 30.7773Z" fill="#2A2A2A"/></svg>',
				'<svg viewBox="0 0 18 32" class="next"><path d="M1.64062 1.04102L0.273438 2.33984C0 2.68164 0 3.22852 0.273438 3.50195L12.6465 15.875L0.273438 28.3164C0 28.5898 0 29.1367 0.273438 29.4785L1.64062 30.7773C1.98242 31.1191 2.46094 31.1191 2.80273 30.7773L17.1582 16.4902C17.4316 16.1484 17.4316 15.6699 17.1582 15.3281L2.80273 1.04102C2.46094 0.699219 1.98242 0.699219 1.64062 1.04102Z" fill="#2A2A2A"/></svg>',
			],
			nav: true,

			responsive: {
				0: {
					items: 1,
					margin: 10,
          nav: false
				},
				575: {
					items: 3,
					margin: 15,
          nav: false
				},
				992: {
					items: 4,
					margin: 26,
				},
				1400: {
					items: 4,
					margin: 26,
				},
				1700: {
					items: 4,
					margin: 26,
				},
			},
		});
	}
	function relatedBlogCarousel(x = ".related-blog-slider") {
		$(x).addClass("owl-carousel").addClass("owl-theme");
		$(x).owlCarousel({
			loop: false,
			dots: false,
			autoWidth: false,
			items: 4,
			navText: [
				'<svg viewBox="0 0 18 32" class="prev"><path d="M15.791 30.7773L17.1582 29.4785C17.4316 29.1367 17.4316 28.5898 17.1582 28.3164L4.78516 15.875L17.1582 3.50195C17.4316 3.22852 17.4316 2.68164 17.1582 2.33984L15.791 1.04102C15.4492 0.699219 14.9707 0.699219 14.6289 1.04102L0.273438 15.3281C0 15.6699 0 16.1484 0.273438 16.4902L14.6289 30.7773C14.9707 31.1191 15.4492 31.1191 15.791 30.7773Z" fill="#2A2A2A"/></svg>',
				'<svg viewBox="0 0 18 32" class="next"><path d="M1.64062 1.04102L0.273438 2.33984C0 2.68164 0 3.22852 0.273438 3.50195L12.6465 15.875L0.273438 28.3164C0 28.5898 0 29.1367 0.273438 29.4785L1.64062 30.7773C1.98242 31.1191 2.46094 31.1191 2.80273 30.7773L17.1582 16.4902C17.4316 16.1484 17.4316 15.6699 17.1582 15.3281L2.80273 1.04102C2.46094 0.699219 1.98242 0.699219 1.64062 1.04102Z" fill="#2A2A2A"/></svg>',
			],
			nav: true,
			responsive: {
				0: {
					items: 1,
					margin: 10,
          nav: false
				},
				575: {
					items: 3,
					margin: 15,
          nav: false
				},
				992: {
					items: 4,
					margin: 26,
				},
				1400: {
					items: 4,
					margin: 26,
				},
				1700: {
					items: 4,
					margin: 26,
				},
			},
		});
	}
	function profileTeamCarousel(x = ".team-slider-wrapper") {
		$(x).addClass("owl-carousel").addClass("owl-theme");
		$(x).owlCarousel({
			loop: false,
			dots: false,
			autoWidth: true,
			margin: 20,
			navText: [
				'<svg viewBox="0 0 18 32" class="prev"><path d="M15.791 30.7773L17.1582 29.4785C17.4316 29.1367 17.4316 28.5898 17.1582 28.3164L4.78516 15.875L17.1582 3.50195C17.4316 3.22852 17.4316 2.68164 17.1582 2.33984L15.791 1.04102C15.4492 0.699219 14.9707 0.699219 14.6289 1.04102L0.273438 15.3281C0 15.6699 0 16.1484 0.273438 16.4902L14.6289 30.7773C14.9707 31.1191 15.4492 31.1191 15.791 30.7773Z" fill="#2A2A2A"/></svg>',
				'<svg viewBox="0 0 18 32" class="next"><path d="M1.64062 1.04102L0.273438 2.33984C0 2.68164 0 3.22852 0.273438 3.50195L12.6465 15.875L0.273438 28.3164C0 28.5898 0 29.1367 0.273438 29.4785L1.64062 30.7773C1.98242 31.1191 2.46094 31.1191 2.80273 30.7773L17.1582 16.4902C17.4316 16.1484 17.4316 15.6699 17.1582 15.3281L2.80273 1.04102C2.46094 0.699219 1.98242 0.699219 1.64062 1.04102Z" fill="#2A2A2A"/></svg>',
			],
			nav: true,
		});
	}
	function producttimerCarousel(x = ".timer-product-wrapper") {
		$(x).addClass("owl-carousel").addClass("owl-theme");
		$(x).owlCarousel({
			loop: false,
			dots: false,
			autoWidth: false,
			items: 4,
			navText: [
				'<svg viewBox="0 0 18 32" class="prev"><path d="M15.791 30.7773L17.1582 29.4785C17.4316 29.1367 17.4316 28.5898 17.1582 28.3164L4.78516 15.875L17.1582 3.50195C17.4316 3.22852 17.4316 2.68164 17.1582 2.33984L15.791 1.04102C15.4492 0.699219 14.9707 0.699219 14.6289 1.04102L0.273438 15.3281C0 15.6699 0 16.1484 0.273438 16.4902L14.6289 30.7773C14.9707 31.1191 15.4492 31.1191 15.791 30.7773Z" fill="#2A2A2A"/></svg>',
				'<svg viewBox="0 0 18 32" class="next"><path d="M1.64062 1.04102L0.273438 2.33984C0 2.68164 0 3.22852 0.273438 3.50195L12.6465 15.875L0.273438 28.3164C0 28.5898 0 29.1367 0.273438 29.4785L1.64062 30.7773C1.98242 31.1191 2.46094 31.1191 2.80273 30.7773L17.1582 16.4902C17.4316 16.1484 17.4316 15.6699 17.1582 15.3281L2.80273 1.04102C2.46094 0.699219 1.98242 0.699219 1.64062 1.04102Z" fill="#2A2A2A"/></svg>',
			],
			nav: true,
			responsive: {
				0: {
					items: 1,
					margin: 10,
          nav: false
				},
				575: {
					items: 3,
					margin: 15,
				},
				992: {
					items: 2,
					margin: 26,
					touchDrag: true,
					mouseDrag: true,
				},
				1200: {
					items: 3,
					margin: 26,
					touchDrag: true,
					mouseDrag: true,
				},
				1440: {
					items: 4,
					margin: 26,
				},
			},
		});
	}
});

function equaliseHeight() {
	$.fn.extend({
		equalHeight: function () {
			var top = 0;
			var row = [];
			var classname = ("equalHeight" + Math.random()).replace(".", "");
			$(this)
				.each(function () {
					var thistop = $(this).offset().top;
					if (thistop > top) {
						$("." + classname).removeClass(classname);
						top = thistop;
					}
					$(this).addClass(classname);
					$(this).height("auto");
					var h = Math.max.apply(
						null,
						$("." + classname)
							.map(function () {
								return $(this).outerHeight();
							})
							.get()
					);
					$("." + classname).height(h);
				})
				.removeClass(classname);
		},
	});
	$(".common-product-slider-section .product-item__title").equalHeight();
	$(".home-event-section .home-event-wrapper .inner-block").equalHeight();
	$(".team-slide-grid .slide-inner .profile-content p").equalHeight();
}
function max_equal_height() {
	$.fn.extend({
		max_equal_height: function () {
			var maxHeight = 0;
			$(this).each(function () {
				if ($(this).height() > maxHeight) {
					maxHeight = $(this).height();
				}
			});
			$(this).height(maxHeight);
		},
	});
	$(
		".home-event-section .home-event-wrapper .right-block .right-inner-block .gray-bg-wrapper"
	).max_equal_height();
}

function grid_slider_overlay() {
	if (
		$(".common-product-slider-section .slider-outer-wrapper").length &&
		$(window).width() > 1920
	) {
		var right_p =
			$(window).innerWidth() -
			$(".common-product-slider-section .index-products-wrapper").width() -
			$(".common-product-slider-section .index-products-wrapper").offset().left;
		$(
			"<style>.common-product-slider-section .index-products-wrapper:after { right: " +
				-right_p +
				"px; }</style>"
		).appendTo("head");
	}
}
function grid_slider_overlay_width() {
	if ($(".common-product-slider-section .slider-outer-wrapper").length) {
		if ($(window).width() < 575) {
			var o_width =
				$(
					".common-product-slider-section .index-products-wrapper .owl-item"
				).outerWidth() / 2.68;
			$(
				"<style>.common-product-slider-section .index-products-wrapper:after { width: " +
					o_width +
					"px; }</style>"
			).appendTo("head");
		} else if ($(window).width() < 992) {
			var o_width =
				$(
					".common-product-slider-section .index-products-wrapper .owl-item"
				).outerWidth() / 2 + 30;
			$(
				"<style>.common-product-slider-section .index-products-wrapper:after { width: " + o_width + "px; }</style>"
			).appendTo("head");
		} else {
			var o_width =
				$(".common-product-slider-section .index-products-wrapper .owl-item").outerWidth() / 2 + 50;
			$(
				"<style>.common-product-slider-section .index-products-wrapper:after { width: " + o_width + "px; }</style>"
			).appendTo("head");
		}
	}
}

function collection_video() {
	let videoClass = 'video-wrapper';
	if ($(".inner-page-banner.collection-banner.has-video-block").length) {
		var collection_margin = $(window).innerWidth() -
			$( ".inner-page-banner.collection-banner.has-video-block ." + videoClass ).width() -
			$( ".inner-page-banner.collection-banner.has-video-block ." + videoClass ).offset().left;
      
		$(".inner-page-banner.collection-banner.has-video-block ." + videoClass ).css({ marginRight: -collection_margin});
	}
}

$(document).ready(function () {
	//     $('.brand-logo-slider-section .logo-bar__item').each(function(index) {
	//       if (index % 2 == 0 ) { // wrap by 2 items
	//         $(this).add($(this).next('.logo-bar__item')).wrapAll('<div class="carousel-column-wrap" />');
	//       }
	//     });
	truncateTitle();
	facilityAccordion();
	collectionAccordion();
	$(".index-products-wrapper").removeClass("not-visible");
	$(".index-products-wrapper").addClass("visible-content");

	$(".collection-menus").click(function () {
		var section_id = $(this)
			.parent()
			.parent()
			.parent()
			.parent()
			.parent()
			.attr("data-section-id");
		$(".index-products-wrapper.collection-" + section_id).css("opacity", "0");
		$(".menu-" + section_id).removeClass("active");
		$(".collection-" + section_id).removeClass("visible-content");
		$(".collection-" + section_id).addClass("not-visible");
		$(this).addClass("active");
		$("#collection-" + $(this).attr("target")).addClass("visible-content");
		$("#collection-" + $(this).attr("target")).removeClass("not-visible");
		setTimeout(function () {
			$(".index-products-wrapper.collection-" + section_id).css("opacity", "1");
			equaliseHeight();
		}, 300);
	});
	setTimeout(function () {
		grid_slider_overlay();
		grid_slider_overlay_width();
		$(".index-products-wrapper").addClass("not-visible");
		$(".index-products-wrapper").removeClass("visible-content");
		$(".collection-1").removeClass("not-visible");
		$(".collection-1").addClass("visible-content");
	}, 500);
	setTimeout(function () {
		equaliseHeight();
	}, 1000);
	setTimeout(function () {
		$(".common-product-slider-section").addClass("visible");
	}, 1550);
	max_equal_height();

	$(".tab-heading li a").click(function () {
		var _this_id = $(this).data("link");
		$(this).closest("li").addClass("active").siblings().removeClass("active");
		$(this)
			.closest(".tabbing-outer")
			.find(".tab-content")
			.removeClass("active");
		$(this)
			.closest(".tabbing-outer")
			.find('.tab-content[data-target="' + _this_id + '"]')
			.addClass("active");
	});

	$(".home-tab-acordian-section .accordian-wrapper .accordian-outer .accordian-heading").click(function () {
		var _this_id = $(this).data("link");
		$(this).toggleClass("active");
		$(this)
			.closest(".accordian-outer")
			.siblings()
			.find(".accordian-heading")
			.removeClass("active");
		$(this)
			.closest(".accordian-outer")
			.find(".accordian-content")
			.stop(true, true)
			.slideToggle("slow");
		$(this)
			.closest(".accordian-outer")
			.siblings()
			.find(".accordian-content")
			.stop(true, true)
			.slideUp("slow");
		$(this)
			.closest(".accordian-outer")
			.find(".accordian-content")
			.toggleClass("active");
		$(this)
			.closest(".accordian-outer")
			.siblings()
			.find(".accordian-content")
			.removeClass("active");
		$(this)
			.closest(".acoordian-parent")
			.find('.tab-content-inner[data-target="' + _this_id + '"]')
			.addClass("active")
			.siblings()
			.removeClass("active");
	});

	$(
		".contact-form-accordian-wrapper .accordian-outer .accordian-heading"
	).click(function () {
		$(this)
			.closest(".accordian-outer")
			.find(".accordian-content")
			.stop(true, true)
			.slideToggle("slow");
		$(this)
			.closest(".accordian-outer")
			.siblings()
			.find(".accordian-content")
			.stop(true, true)
			.slideUp("slow");
		$(this)
			.closest(".accordian-outer")
			.find(".accordian-content")
			.toggleClass("active");
		$(this)
			.closest(".accordian-outer")
			.siblings()
			.find(".accordian-content")
			.removeClass("active");
		$(this).toggleClass("active");
		$(this)
			.closest(".accordian-outer")
			.siblings()
			.find(".accordian-heading")
			.removeClass("active");
	});
	$(".product-accordian-heading").click(function () {
		$(this)
			.closest(".product-accordian")
			.find(".product-accordian-content")
			.stop(true, true)
			.slideToggle("slow");
		$(this).closest(".product-accordian").toggleClass("active");
	});
	// collection_video();
	$(
		".header .main-header .header-icon-outer .header-icon li.search-link a"
	).click(function () {
		$("body").addClass("search-menu-open");
	});
	$("body").delegate(
		".header__search-bar-wrapper .search-bar__top-wrapper .search-bar__close-button",
		"click",
		function () {
			$("body").removeClass("search-menu-open");
		}
	);
	$(".scroll-to-section").click(function () {
		var _this_id = $(this).attr("data-id");
		var _this_content_offset =
			$("*[block-id=" + _this_id + "]").offset().top -
			$(".product-nav").innerHeight();
		$("html,body").animate(
			{
				scrollTop: _this_content_offset,
			},
			1000
		);
	});
	if (jQuery(".cms-content table").length) {
		jQuery(".cms-content table").each(function () {
			jQuery(this).wrap('<div class="table-responsive"></div>');
		});
	}

	$(window)
		.on("scroll", function () {
			if ($(".page-nav__wrapper").length) {
				var scrollTop = $(window).scrollTop(),
					elementOffset = $(".page-nav__wrapper").offset().top,
					distance = elementOffset - scrollTop,
					pageNavHeight = $(".page-nav").outerHeight();

				if (distance < 0) {
					$(".page-nav").addClass("sticky");

					$(".page-nav__wrapper").height(pageNavHeight);
				} else {
					$(".page-nav").removeClass("sticky");
					$(".page-nav__wrapper").css("height", "auto");
				}
			}
		})
		.scroll();

	$(document).on("click", 'a[href^="#"]:not(.btn-accordion)', function (event) {
		if ($(this).hasClass(".not-scroll")) {
			return;
		}
		event.preventDefault();

		$("html, body").animate(
			{
				scrollTop: $($.attr(this, "href")).offset().top - 88,
			},
			500
		);
	});
});

$(window).resize(function () {
	equaliseHeight();
	grid_slider_overlay();
	grid_slider_overlay_width();
	truncateTitle();
	setTimeout(function () {
		max_equal_height();
		// collection_video();
		$(".common-product-slider-section").each(function () {
			$(this)
				.find(".index-products-wrapper")
				.each(function () {
					var viewport = $(window).width();
					var itemCount = $(this).find(".owl-item").length;
					console.log($(this).find(".owl-item").length);
					if (
						(viewport >= 992 && itemCount < 4) ||
						(viewport >= 575 && viewport < 991 && itemCount < 2) ||
						(viewport >= 375 && viewport < 0 && itemCount > 1)
					) {
						$(this).addClass("hide-nav");
					} else {
						$(this).removeClass("hide-nav");
					}
				});
		});
		$(".owl-carousel").each(function () {
			if (
				$(this).find(".owl-prev").hasClass("disabled") &&
				$(this).find(".owl-next").hasClass("disabled")
			) {
				$(this).addClass("hide-btn");
			} else {
				$(this).removeClass("hide-btn");
			}
		});
	}, 500);
});

$(window).scroll(function () {
	if ($(".product-nav").length) {
		var scroll = $(window).scrollTop();
		var os = $(".product-wrapper").offset().top;
		var ht = $(".product-wrapper").height();
		if (scroll > os + ht) {
			$(".product-nav").addClass("sticky");
			$("body").css("padding-top", "50px");
		} else {
			$(".product-nav").removeClass("sticky");
			$("body").css("padding-top", "0");
		}
	}
});
$(window).on("load", function () {
	setTimeout(function () {
		equaliseHeight();
		$(".common-product-slider-section").each(function () {
			$(this)
				.find(".index-products-wrapper")
				.each(function () {
					var viewport = $(window).width();
					var itemCount = $(this).find(".owl-item").length;

					if (
						(viewport >= 992 && itemCount < 4) ||
						(viewport >= 575 && viewport < 991 && itemCount < 2) ||
						(viewport >= 375 && viewport < 0 && itemCount > 1)
					) {
						$(this).addClass("hide-nav");
					} else {
						$(this).removeClass("hide-nav");
					}
				});
		});
		$(".owl-carousel").each(function () {
			if (
				$(this).find(".owl-prev").hasClass("disabled") &&
				$(this).find(".owl-next").hasClass("disabled")
			) {
				$(this).addClass("hide-btn");
			} else {
				$(this).removeClass("hide-btn");
			}
		});
		$(".jdgm-prev-badge").each(function () {
			if ($(this).attr("data-number-of-reviews") > 0) {
				//$( this ).closest('.stock-review_wrapper').removeClass('has-no-review-list');
				var x = this.parentElement.parentElement.parentElement.classList.remove(
					"has-no-review-list"
				);
			} else {
				$(".product-feature-list li#product_review").css("display", "none");
			}
		});
	}, 1500);
});
mobileRelatedProduct();
function mobileRelatedProduct(){
  const $btn = $('.collection-related-products-mobile');

  if ( $btn.length === 0 ){
    return;
  }

  $btn.on('click', function(e){
    const $target = $(e.target).closest('button'),
          $dropdown = $target.find('.related-collection-wrapper');

    if ($target.hasClass('active')){
      $target.removeClass('active');
      $dropdown.slideUp();
    } else {
      $target.addClass('active');
      console.log($dropdown);
      $dropdown.slideDown();
    }
  });
}

function scrollToDescription(e){
  const $target = $(e.target).closest('a'),
        accordion = $target.attr('href'),
        $accordion = $(accordion),
        $accordionHeading = $accordion.find('.product-accordian-heading');
  
  if ( !$accordion.hasClass('active') && $(window).width() <= 767 ){
    $accordionHeading.click();
  }
}

searchPage();
function searchPage(){
  const $searchTemplate = $('#shopify-section-search-template');

  if ( $searchTemplate.length === 0 ){
    return;
  }

  const searchTerm = $('#search-term').val(),
        currentPageType = getParam('type'),
        currentPageFilter = getParam('filter'),
        searchTypes = ['product', 'article', 'page'];

  if ( currentPageFilter ){
    $('[data-search-type="' + currentPageType + '-' + currentPageFilter + '"]').closest('a').addClass('active');
  } else {
    $('[data-search-type="' + currentPageType + '"]').closest('a').addClass('active');
  }

  if ( currentPageType === 'article' || currentPageType === 'page' ){
    setTimeout(function(){ 
      $('title').html('Search results for "' + searchTerm + '"');
    }, 1000);
  }

  filterArticle();
  filterEvent();

  searchTypes.forEach(function(type, i){

    if ( currentPageType !== 'product' && type === 'product' ){
      getSearch(searchTerm, type);
      return;
    }

    if ( type === 'page' ){
      getSearch(searchTerm, type, ['locations']);
      return;
    }

    if ( type === 'article' ){
      getSearch(searchTerm, type, ['news', 'event']);
      return;
    }

  });

  function getSearch(term, type, filter){
    let url = 'https://www.golfwarehouse.nz/search?type=' + type + '&q=' + term + '&view=json';

    $.ajax({
      type: "GET",
      dataType: "json",
      contentType: "application/json",
      url: url
    }).done(function(data, status, xhr){
        console.log(data); 

        if ( filter && filter.length ){
          if ( type === 'page' ){
            filter.forEach(function(fil, i){
              let count = 0;
              data.results.forEach(function(res, i){
                if ( res.template === fil ){
                  count += 1;
                }
              });
              $('[data-search-type="' + type + '-' + fil + '"]').html(count);
            });
          }
          if ( type === 'article' ){
            filter.forEach(function(fil, i){
              let count = 0;
              data.results.forEach(function(res, i){
                if ( 
                  fil === 'news' && 
                  ( 
                    res.blog.indexOf('news') > -1 || 
                    res.blog.indexOf('press') > -1 
                  ) 
                ){
                  count += 1;
                }
                if ( 
                  fil === 'event' && 
                  ( 
                    res.blog.indexOf('event') > -1
                  ) 
                ){
                  count += 1;
                }
              });
              $('[data-search-type="' + type + '-' + fil + '"]').html(count);
            });
          }
        }
        $('[data-search-type="' + type + '"]').html(data.results_count);

    });

  }

  function filterArticle(){

    if ( currentPageType !== 'article' ){
      return;
    }

    $('.blog-listing-inner').each(function(){
      const $article = $(this),
            blog = $article.attr('data-blog');

      if ( 
        currentPageFilter === 'news' && 
        blog.indexOf('news') === -1 && 
        blog.indexOf('press') === -1 
      ){
        $article.addClass('hide');
      }

      if ( 
        currentPageFilter === 'event' && 
        blog.indexOf('event') === -1 
      ){
        $article.addClass('hide');
      }

    });

    $('.blog-listing').removeClass('hide');
  }

  function filterEvent(){
    if ( currentPageType !== 'page' ){
      return;
    }

    if ( currentPageFilter !== 'locations' ){
      $('.container').removeClass('hide');
      return;
    }

    $('.page-item-wrapper').addClass('hide');

    $('.container').removeClass('hide');
  }


  function getParam(parameterName) {
    var result = '',
        items = location.search.substr(1).split("&");

    $.each(items, function(i, item){
      var tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });

    return result;
  }
}
gwBlog();
function gwBlog(){
  const $blog = $('#shopify-section-article-template .article-content--container');

  if ( $blog.length === 0 ){
    return;
  }

  $blog.find('img').each(function(){
    let image = $(this).attr('src')
                  .replace('_16x16', '')
                  .replace('_32x32', '')
                  .replace('_50x50', '')
                  .replace('_100x100', '')
                  .replace('_160x160', '')
                  .replace('_240x240', '')
                  .replace('_480x480', '')
                  .replace('_600x600', '')
                  .replace('_1024x1024', '')
                  .replace('_2048x2048', '')
                  .replace('_2048x2048', '');

    $(this).wrap('<a href="' + image + '" data-fancybox="gallery""></a>');

  });
}

staffPic();
function staffPic(){
	const $staffPic = $('.staff-pick');

	if ( $staffPic.length == 0 || $(window).width() >= 768 ){
		return;
	}

	$(document).on('click touchend', function(e){
		const $target = $(e.target),
					$targetStaff = $target.closest('.staff-pick');

		if ( !$targetStaff.length && $staffPic.hasClass('hover') ){
			$staffPic.removeClass('hover');
			return;
		}

		if ( !$targetStaff.length ){
			return;
		}

		e.preventDefault();

		if ( $targetStaff.hasClass('no-click') ){
			if ( $targetStaff.hasClass('hover') ){
				$targetStaff.removeClass('hover');
				return;
			}
			$targetStaff.addClass('hover');
			return;
		}

		const link = $targetStaff.attr('href');

		if ( $targetStaff.hasClass('hover') ){
			window.location = link;
			return;
		}	
	
		$targetStaff.addClass('hover');

	});
}

//On mobile, truncate blog title tiles
function truncateTitle(){
	const $title = $('[data-truncate]'),
				docWidth = $(window).width();

	if ( $title.length == 0 ) return;

	$title.each(function(){
		const $el = $(this),
					oriTitle = $el.attr('title'),
					shortTitle = $el.attr('data-short-title');
		
		if (docWidth >= 767 ){
			$el.html(oriTitle);
		} else {
			$el.html(shortTitle);
		}
	});

}

//Collapse accordion
function facilityAccordion(){
	const $facility = $('.home-tab-acordian-section'),
				docWidth = $(window).width();

	if ( $facility.length == 0 || docWidth >= 767 ) return;

	const $accordionHeader = $facility.find('.accordian-heading'),
				$accordiongContent = $facility.find('.accordian-content');
	
	$accordionHeader.removeClass('active');
	$accordiongContent.removeClass('active').css('display', 'none');
}

function collectionAccordion(){
	const $collectionAccordion = $('.accordion-wrapper'),
				$accordionHeader = $collectionAccordion.find('.accordion-header');

	$accordionHeader.on('click', function(){
		const $target = $(this);

		if ( !$target.hasClass('active') ){
			$(this).next().slideDown();
			$accordionHeader.text('Less Details');
		} else {
			$(this).next().slideUp();
			$accordionHeader.text('More Details');
		}

		$target.toggleClass('active');


	});
}
function productAvailability() {
    let retryCount = 0;
    // Poll for the container and its child list
    function waitForInventoryList() {
        const $container = document.querySelector("#tomit_inventory_list");
        const $liElements = $container ? $container.querySelectorAll("li") : null;


        console.log('container here', $container);  // Check if the container exists
        console.log('tomit_inventory_list here', $liElements);  // Check if the inventory list exists inside the container
 
        if ($liElements && $liElements.length > 0) {
          const $trigger = $('.product-item__inventory span, .product-item__inventory a');
            console.log('initInventory hitting', $trigger);
            // Init: Show the inventory trigger
            $trigger.addClass('show');
          
            // Once #tomit_inventory_list is found, set up the MutationObserver
            const observer = new MutationObserver(function(mutations) {
                console.log("Mutation observed:", mutations);  // Log mutation events
                initInventory(); 
            });

            observer.observe($container, {
                subtree: true,
                childList: true,
                attributes: true  // Watching for attribute changes as well
            });

            console.log('Observer started!');
        } else {
            retryCount++;  // Increment the retry counter

            if (retryCount >= 20) {
                console.log('Retry limit reached, stopping check.');
                return; // Stop checking after 5 attempts
            }

            setTimeout(waitForInventoryList, 500); // Recheck every 500ms
        }
    }

    // Start checking for the container and the inventory list
    waitForInventoryList();

    const $button = $('[data-src="#inventoryLocationInfo_wrapper"]');
    $button.on('click', runInventory);

    function initInventory() {
        const $trigger = $('.product-item__inventory span, .product-item__inventory a');
        console.log('initInventory hitting', $trigger);
        // Init: Show the inventory trigger
        $trigger.addClass('show');
    }

    function runInventory() {
        const $form = $('form.product-form'),
            $select = $form.find('.default_variant_select select'),
            selectedVariant = $select.find('option:selected').text(),
            $locationWrapper = $('#inventoryLocationInfo_wrapper'),
            $variant = $locationWrapper.find('.product-variant');

        // Display Variant Info
        $variant.text(selectedVariant);

        // Reformat locations
        reformatLocations();
    }

    function reformatLocations() {
        const $ul = $('#tomit_inventory_list'),
            $li = $ul.find('li'),
            $display = $('#inventoryLocationInformationDisplay');

        let data = [],
            html = '';

        $li.each(function(i) {
            const $target = $(this),
                name = $target.find('.location').text().trim(),
                stockLevel = $target.find('.stockCount span').text().trim();

            let temp = {};

            temp.loc = name;
            temp.stock = stockLevel;

            data.push(temp);
        });

        console.log('HH location data ', data);

        // Loop through data to generate the HTML
        data.forEach(function(area, i) {
            let type = 'red';

            let trimmerArea = area.stock.trim();

            switch (trimmerArea) {
                case 'High Stock':
                    type = 'green';
                    break;

                case 'Low Stock':
                    type = 'orange';
                    break;

                case 'Out of Stock':
                    type = 'red';
                    break;
            }

            html += '<div class="area">';
            html += `<span class="stores">${area.loc}</span>`;
            html += `<span class="stock ${type}">${area.stock}</span>`;
            html += '</div>';

            console.log('area stock type', area.stock, type);
        });

        $display.html(html);
    }
}

productAvailability();


function printContent(elem){
	var mywindow = window.open('', 'PRINT', 'height=400,width=600');

	mywindow.document.write('<html><head><title>' + document.title  + '</title>');
	mywindow.document.write('</head><body >');
	mywindow.document.write('<h1>' + document.title  + '</h1>');
	mywindow.document.write(document.getElementById(elem).innerHTML);
	mywindow.document.write('<scr' + 'ipt type="text/javascript">setTimeout(function () { window.print(); }, 500);window.onfocus = function () { setTimeout(function () { window.close(); }, 500); }</scr' + 'ipt>');
	mywindow.document.write('</body></html>');
	
	mywindow.document.close(); // necessary for IE >= 10
	mywindow.focus(); // necessary for IE >= 10*/

	return true;
}

document.addEventListener('DOMContentLoaded', function() {
   document.getElementsByClassName("staff-pick").href = "#";
}, false);

//Remove extra sliders injected by owl-carousel
setTimeout(function () {
	$('.index-products-wrapper .owl-item').each(function(){
		let slider = $(this).find('div');
		if(slider.length == 0){
			$(this).remove();
		}
	});
}, 2500);


$(function () {

	$('.blog-title span').on('click', function(){
		$(this).parents('.blog-title').siblings('ul').slideToggle();
		$(this).parents('.blog-title').toggleClass('open')
	});



setTimeout(function(){
	$('.sidebar .article-search').attr("placeholder", "Search posts here...");
}, 1000);

var badges = document.getElementsByClassName('product-badges')[0]
localStorage.setItem("badges", badges.innerHTML)

$(document).ready(function() {
  setTimeout(function(){
      // Product item badges
      $('.product-item .product-item__image-wrapper').append(localStorage.badges);
      $('.product-item').each(function() {
        var tags = $(this).find('.product-item__tags').data('tag');
        const tagsSplit = tags.split(',');
        $(this).find('.custom-product-badge').each(function() {
          var badgeTag = $(this).data('tag');
          var badgeWidth = $(this).data('alt-width');
          // $(this).css('width', badgeWidth + 'px');
          // $(this).css('height', badgeWidth + 'px');
          if(jQuery.inArray(badgeTag, tagsSplit) != -1) {
             $(this).show();
          } else {
            $(this).remove();
          } 
        });
      });
    }, 1000);
  })

  // Product template badges
  $('.product-wrapper').find('.product-gallery__carousel-wrapper').append(localStorage.badges);
  var productPageTags = $('.product-wrapper').data('tags');
  const productPageTagsSplit = productPageTags.split(',');
  $('.product-gallery .custom-product-badge').each(function() {
    var productBadgeTag = $(this).data('tag');
    if(jQuery.inArray(productBadgeTag, productPageTagsSplit) != -1) {
       $(this).show();
    } else {
      $(this).remove();
    } 
  });
});